import { render, staticRenderFns } from "./v-chat-composer.vue?vue&type=template&id=1cb46da8&scoped=true&"
var script = {}
import style0 from "./v-chat-composer.vue?vue&type=style&index=0&id=1cb46da8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb46da8",
  null
  
)

export default component.exports